class Utils {
	constructor() {
		const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

		if (isSafari) {
			const safariVersionMatch = navigator.userAgent.match(/Version\/(\d+)/);
			const safariVersion = safariVersionMatch ? parseInt(safariVersionMatch[1]) : 0;
			const isSafari14OrEarlier = safariVersion < 15;

			if (isSafari14OrEarlier) {
				// this.SmoothScrollFallback();
			}
		}

		this.WindowWidth();
		window.addEventListener("resize", () => {
			this.WindowWidth();
		});
	}

	/**
	 * Smooth scroll fallback for Safari v14 and below
	 * @constructor
	 */
	SmoothScrollFallback() {
		console.log("SmoothScrollFallback");
		const links = document.querySelectorAll('a[href^="#"]:not(.no)');
		links.forEach((link) => {
			link.addEventListener("click", (e) => {
				e.preventDefault();
				const href = link.getAttribute("href");
				const target = document.querySelector(href);
				const offset = target.offsetTop + window.innerHeight;
				console.log(href, target, offset);
				window.scrollTo({
					top: offset,
					behavior: "smooth",
				});
			});
		});
	}

	/**
	 * Set CSS variable for window width
	 * @constructor
	 */
	WindowWidth() {
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		const windowWidth = window.innerWidth - scrollbarWidth;
		document.documentElement.style.setProperty("--window-width", windowWidth + "px");
	}
}

export default Utils;
